<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card color="#ac8a2e" inline title="Scouting">
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="nombre" rules="required|max:45">
                      <v-text-field v-model="dataForm.nombre" color="#ac8a2e" :error-messages="errors" label="Nombre" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="pasaporte">
                      <v-select
                        v-model="dataForm.pasaporte_id"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Pasaporte"
                        item-value="id"
                        item-text="descripcion"
                        :items="pasaportes"
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="año" rules="required|max:4">
                      <v-text-field v-model="dataForm.ano" color="#ac8a2e" :error-messages="errors" label="Año" type="number" min="1950" max="3000" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="dataForm.club_id"
                      color="#ac8a2e"
                      label="Club"
                      item-value="id"
                      item-text="descripcion"
                      :items="clubs"
                      clearable
                    >
                      <template v-slot:append-outer>
                        <v-btn elevation="1" color="success" fab x-small @click="mostrarClubForm = true">
                          <v-icon>
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:item="{ attrs, item, on }">
                        <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.descripcion" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="pierna habil" rules="required">
                      <v-select
                        v-model="dataForm.pierna_habil"
                        color="gold"
                        item-color="gold"
                        label="Pierna habil"
                        :items="piernas"
                        :error-messages="errors"
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="contacto" rules="max:45">
                      <v-text-field v-model="dataForm.contacto" color="gold" :error-messages="errors" label="Contacto" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="agente" rules="max:45">
                      <v-text-field v-model="dataForm.agente" color="gold" :error-messages="errors" label="Agente" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="posicion" rules="required">
                      <v-autocomplete
                        v-model="dataForm.posicion_detalle_id"
                        color="gold"
                        :error-messages="errors"
                        label="Posición"
                        item-value="id"
                        item-text="descripcion"
                        :items="posiciones"
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item
                            v-bind="attrs"
                            active-class="gold elevation-4 white--text"
                            class="mx-3 mb-3 v-sheet"
                            elevation="0"
                            v-on="on"
                          >
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="dataForm.scout_id"
                      color="#ac8a2e"
                      label="Scout"
                      item-value="user_id"
                      item-text="fullName"
                      :items="scouts"
                      :disabled="logedStaff"
                      clearable
                    >
                      <template v-slot:item="{ attrs, item, on }">
                        <v-list-item
                          v-bind="attrs"
                          active-class="gold elevation-4 white--text"
                          class="mx-3 mb-3 v-sheet"
                          elevation="0"
                          v-on="on"
                        >
                          <v-list-item-content>
                            <v-list-item-title v-text="item.fullName" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="descripcion" rules="max:250">
                      <v-textarea
                        v-model="dataForm.obs"
                        color="#ac8a2e"
                        :error-messages="errors"
                        name="input-6-1"
                        label="Observaciones"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="space-between">
                      <v-btn v-if="mode !=='show'" color="#ac8a2e" class="mr-0" type="submit" :disabled="$disabled()">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
    </v-row>
    <clubs-form :show="mostrarClubForm" @close="mostrarClubForm = false" @close-dialog="closeDialog" />
  </v-container>
</template>

<script>
  import ClubsForm from '../altas/ClubsForm.vue'

  export default {
    components: {
      ClubsForm,
    },
    props: {
      mode: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      tittle: 'Nuevo',
      mostrarClubForm: false,
      clubs: [],
      pasaportes: [],
      posiciones: [],
      scouts: [],
      logedStaff: false,
      piernas: ['Izquierda', 'Derecha'],
      dataForm: {
        id: '',
        nombre: '',
        ano: '',
        club_id: '',
        pierna_habil: '',
        contacto: '',
        agente: '',
        obs: '',
        pasaporte_id: '',
        posicion_detalle_id: '',
      },
    }),
    created () {
      // this.$store.commit('loaderOn', 1)
      this.setTittle()
      this.getPosiciones()
      this.getPasaportes()
      this.getClubs()
      this.getScouts()
      this.setScout()
      if (this.mode !== 'new') {
        this.getScouting()
      }
    },
    methods: {
      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nuevo scouting'
        } else if (this.mode === 'show') {
          this.tittle = 'Informacion scouting'
        } else {
          this.tittle = 'Editar scouting'
        }
      },
      closeDialog (club) {
        console.log(club.id)
        this.getClubs()
        this.dataForm.club_id = club.id
      },

      getClubs: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/club_get' }).then(response => { this.clubs = response })
      },
      getPasaportes: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pasaporte_get' }).then(response => { this.pasaportes = response })
      },
      getPosiciones: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/posicion_detalle_get' }).then(response => { this.posiciones = response })
      },
      getScouts: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_scout' }).then(response => { this.scouts = response })
      },
      getScouting: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/scouting_get/' + this.id }).then(response => { this.dataForm = response })
      },
      setScout: function () {
        if (this.mode === 'new') {
          this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_loged_scout' }).then(response => {
            if (response) {
              this.dataForm.scout_id = response
              this.logedStaff = true
            }
          })
        }
      },
      validateForm (scope) {
        this.enviarScouting()
      },
      enviarScouting: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/scouting_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de scouting exitosa'] })
          this.$router.push({ path: '/ver/scouting' })
        })
        /* const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/scouting_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de scouting exitosa'] })
          this.$router.push({ path: '/ver/scouting' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        }) */
      },
    },
  }
</script>
